import { Controller } from "@hotwired/stimulus"

// L'étape « signer le document » n'a plus de bouton Suivant : c'est le webhook PandaDoc
// « document.completed » qui la valide. Il diffuse ce nœud avec signed=true, et on soumet alors le
// formulaire d'étape — on rejoue donc exactement le chemin d'un clic sur Suivant (mêmes champs
// cachés de workflow, même turbo_step_advance, mêmes session et utilisateur), sans demander ce clic.
//
// Le rendu initial porte aussi signed=true quand la signature est déjà terminée (rechargement de
// page après le webhook, ou webhook arrivé pendant que l'onglet était ailleurs) : sans ça l'étape
// resterait sans issue, puisqu'il n'y a plus de bouton pour la franchir à la main.
export default class extends Controller {
  static values = { signed: Boolean }

  connect() {
    if (this.signedValue) this.advance()
  }

  advance() {
    const form = this.element.closest("form")
    if (!form) return
    // Une diffusion peut arriver sur un nœud déjà signé au rendu : un seul submit par formulaire.
    if (form.dataset.signatureAutoAdvanceSubmitted === "true") return

    form.dataset.signatureAutoAdvanceSubmitted = "true"
    form.requestSubmit()
  }
}
